import { PackageSearch } from "lucide-react";
import type { CurrentOrders, GarmentWithCount } from "../types";
import { ProductCard } from "./ProductCard";

type ProductGridProps = {
  garments: GarmentWithCount[];
  orderHistory: CurrentOrders;
  onAdd: (garmentName: string, size: string) => void;
};

export function ProductGrid({ garments, orderHistory, onAdd }: ProductGridProps) {
  if (garments.length === 0) {
    return (
      <div className="empty-state">
        <PackageSearch size={32} aria-hidden="true" />
        <h2>Inga plagg hittades</h2>
        <p>Prova ett annat sökord.</p>
      </div>
    );
  }

  return (
    <div className="product-grid">
      {garments.map((garment) => (
        <ProductCard
          key={garment.name}
          garment={garment}
          previousOrders={orderHistory[garment.name] ?? []}
          onAdd={onAdd}
        />
      ))}
    </div>
  );
}
